const isDefaultAsset = (url) => /^\/ws\/blocks/gi.test(url);

export default isDefaultAsset;
